import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response'
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { UserClockInOutResponseModel } from '../business-entities/user-clock-in-out-response-model';
import { UserStampReportResponseModel } from '../business-entities/user-stamp-report-response-model';

@Injectable({
  providedIn: 'root'
})
export class UserClockInOutDataService {

  constructor(private dataProvider: DataService) {
  }

  async getUserClockInOut(model: any): Promise<GenericResponse<Array<UserClockInOutResponseModel>>> {
      return this.dataProvider.Post<GenericResponse<Array<UserClockInOutResponseModel>>>(Urls.GetUserClockInOut, model).toPromise();
  }

  async getUserStampReport(model: any): Promise<GenericResponse<Array<UserStampReportResponseModel>>> {
      return this.dataProvider.Post<GenericResponse<Array<UserStampReportResponseModel>>>(Urls.GetUserStampReport, model).toPromise();
  }

  async getUsers(): Promise<any> {
      return this.dataProvider.GetAll<any>(Urls.GetUserForClocking).toPromise();
  }
  async GetLocationCode(): Promise<any> {
    return this.dataProvider.Get<any>(Urls.GetLocationCodeName).toPromise();
}
}
